import type {
  CatalogLayerCategory,
  CatalogLayerWithOrder,
} from '#/domain/catalog/CatalogLayerCategory'

export interface LayerDtoResponse {
  Id: string
  Title?: string
  Description?: string
  Icon?: string
  Active: boolean
  Available: boolean
  Private: boolean
  Url?: string
  LayerTypeName?: string
  Applications?: string[]
  DisplayOrder?: number
}

export interface LayerCategoryDtoResponse {
  Id: string
  DisplayName?: string
  Applications?: string[]
  LayerList: LayerDtoResponse[]
  OrganizationId?: string
  IsCustom?: boolean
}

export function mapLayerCategoryDto(raw: LayerCategoryDtoResponse): CatalogLayerCategory {
  const layers: CatalogLayerWithOrder[] = raw.LayerList.map((l) => ({
    Id: l.Id,
    Title: l.Title,
    Description: l.Description,
    Icon: l.Icon,
    Active: l.Active,
    Available: l.Available,
    Private: l.Private,
    Url: l.Url,
    LayerTypeName: l.LayerTypeName,
    Applications: l.Applications ?? [],
    DisplayOrder: l.DisplayOrder ?? 0,
    AssignedCategories: [],
  })).sort((a, b) => a.DisplayOrder - b.DisplayOrder)

  return {
    Id: raw.Id,
    DisplayName: raw.DisplayName ?? '',
    Applications: raw.Applications ?? [],
    Layers: layers,
    OrganizationId: raw.OrganizationId,
    IsCustom: raw.IsCustom ?? false,
  }
}
